import Accordion from 'accordion-js'
import 'accordion-js/dist/accordion.min.css';

new Accordion('.about .accordion-container',{
  openOnInit: [0],
});